import React, { useEffect } from 'react';
import Navbar from '../component/Shared/Navbar';
import Footer from '../component/Shared/Footer';
import Hero from '../component/Shared/Hero';
import CatalogueGrid from '../component/Home/CatalogueGrid';
import Feedback from '../component/Shared/Feedback';
import CTAsection from '../component/Shared/CTAsection';

const Home = ({ user }) => {

  useEffect(() => {
    document.title = 'Home | Product Catalogue';
  }, []);

  return (
    <>
      <Navbar />
      <Hero />
      <div className="container">
        <CatalogueGrid />
        <CTAsection />
        <Feedback />
      </div>
      <Footer />
    </>
  );
}
export default Home;
